import { accountApi } from '../../../redux/api/AccountApi';
import { RegisterAccount } from '../types';

export const registerApi = accountApi.injectEndpoints({
    endpoints: (builder) => ({
        registerAccount: builder.mutation<any, RegisterAccount>({
            query: (body) => ({
                url: `register`,
                method: 'POST',
                body
            }),
            transformResponse: (response: { body: any }, meta, arg) => {
                return response.body;
            }

        }),
        checkRegisterPhone: builder.mutation<boolean, RegisterAccount>({
            query: (body) => ({
                url: `register-phone-check`,
                method: 'POST',
                body
            }),
            transformResponse: (response: { body: boolean }, meta, arg) => {
                return response.body;
            }
        }),
        checkRegisterEmail: builder.mutation<boolean, RegisterAccount>({
            query: (body) => ({
                url: `register-email-check`,
                method: 'POST',
                body
            }),
            transformResponse: (response: { body: boolean }, meta, arg) => {
                return response.body;
            }
        }),
        checkRegisterIdentification: builder.mutation<boolean, RegisterAccount>({
            query: (body) => ({
                url: `register-identification-check`,
                method: 'POST',
                body
            }),
            transformResponse: (response: { body: boolean }, meta, arg) => {
                return response.body;
            }
        })
    })
})

export const {
    useRegisterAccountMutation,
    useCheckRegisterPhoneMutation,
    useCheckRegisterEmailMutation,
    useCheckRegisterIdentificationMutation } = registerApi;
